module.exports = __webpack_public_path__ + "img/keyboard_M.918bb5bc.png";